// We want lookups to be:
//  a) disabled if not appropriate for this stage
//  b) divided into general and stage-related
export const stageLookupMapper = (items, thisStage) => {
    const stageBasedLookups = items.filter(item => item.stageFrom && Array.isArray(item.stageFrom));
    const generalLookups = items.filter(item => !item.stageFrom);
    const areHeadersRequired = stageBasedLookups.length && generalLookups.length;
    if (areHeadersRequired) {
        const stagesHeader = { isGroup: "This stage:" };
        const generalHeader = { isGroup: "General:" };
        return [stagesHeader, ...stageBasedLookups, generalHeader, ...generalLookups];
    }
    else {
        return [...stageBasedLookups, ...generalLookups];
    }
};
